"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbags = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 52",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbags` : '') + (description ? ` desc-brandedbags` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbags"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbags"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.72 1.64C18.86.7 19.7 0 20.7 0h27.98c1.03 0 1.89.74 2 1.72l5.3 48.06a1.96 1.96 0 0 1-2 2.13H13.36a1.95 1.95 0 0 1-1.98-2.2l7.34-48.07Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.1 4.57c0-.8.68-1.46 1.52-1.46h13.02c.84 0 1.52.65 1.52 1.46 0 .8-.68 1.46-1.52 1.46H27.62a1.5 1.5 0 0 1-1.52-1.46Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.98 49.6 51.23 6.8A148.83 148.83 0 0 1 7.7 42.62l-1.06 6.9c-.2 1.25.81 2.37 2.14 2.4l45.04.03c1.52.02 2.3-1.12 2.15-2.35Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.25 18.66a2 2 0 0 1 1.98-1.69h19.22a2 2 0 0 1 1.96 1.63l5.78 30.94a2 2 0 0 1-1.97 2.37H2.34A2 2 0 0 1 .37 49.6l4.88-30.94Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "10.71",
    y: "20",
    width: "11.4211",
    height: "1.90648",
    rx: "0.953239",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m2.5 51.9 30.19.1c.85 0 1.62-1.42 1.53-2.24l-4.12-22C21.13 35.11 11.28 42.35.73 47.41l-.33 1.9c-.3 1 .33 2.64 2.1 2.59Z",
    fill: "#CC0058"
  }));
};
var _default = exports.default = brandedbags;